"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormChannels(_a) {
    var user = _a.user, setUser = _a.setUser, activeUser = _a.activeUser, _b = _a.channel, channel = _b === void 0 ? {} : _b;
    if (activeUser.is_admin) {
        return react_1.default.createElement(storybook_1.Users.FormChannelsSuperAdmin, { setUser: setUser, user: user });
    }
    if (user.id) {
        return react_1.default.createElement(storybook_1.Users.FormChannelsAdmin, { setUser: setUser, user: user, channel: channel });
    }
    if (activeUser.role === 'coach') {
        return react_1.default.createElement(storybook_1.Users.FormChannelsCoach, { setUser: setUser, user: user, activeUser: activeUser, channel: channel });
    }
    return react_1.default.createElement(storybook_1.Users.FormChannelsNew, { setUser: setUser, user: user });
}
exports.default = FormChannels;
